<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix principle">
        <span class="title">基本信息</span>
        <template v-if="$route.query.type == 'replenishment'"
          ><el-button
            v-show="show"
            style="float: right; padding: 10px"
            type="primary"
            @click="subWebCall"
            >呼叫</el-button
          ></template
        >

        <el-button
          style="float: right; padding: 10px"
          v-show="!show"
          type="primary"
          >{{ count }}s</el-button
        >
      </div>
      <div class="p_bd">
        <!-- <el-row :gutter="20">
          <el-col :span="12">{{ patientInfo.described }}</el-col>
          <el-col :span="12">
            <div>
              <el-image
                v-for="(item, index) in patientInfo.symptomList"
                :key="index"
                style="width: 50px; height: 50px; margin-right: 10px"
                :src="item"
                fit="cover"
                :preview-src-list="setPreviewList(item)"
              ></el-image>
            </div>
          </el-col>
        </el-row> -->
        <el-row :gutter="20">
          <el-col :span="6">姓名：{{ patientInfo.patientName }}</el-col>
          <el-col :span="6"
            >性别：{{
              patientInfo.patientGender == 10901
                ? '男'
                : patientInfo.patientGender == 10902
                ? '女'
                : '未知'
            }}</el-col
          >
          <el-col :span="6">年龄：{{ patientInfo.patientAge }}岁</el-col>
          <!-- <el-col :span="6">婚姻状态：未婚</el-col> -->
          <el-col
            v-if="['2', '8'].indexOf(patientInfo.goodsId) !== -1"
            :span="6"
            >手机号：{{ patientInfo.patientMobile }}</el-col
          >
        </el-row>
        <el-row :gutter="20" style="margin-top: 20px">
          <el-col :span="6"
            >咨询类别：{{
              patientInfo.treatmentType
                ? patientInfo.treatmentType === 2
                  ? '复诊开药'
                  : '在线咨询'
                : ''
            }}</el-col
          >
          <el-col :span="6">咨询方式：{{ patientInfo.goodsInfo }}</el-col>
          <el-col :span="8"
            >预约时间：{{ patientInfo.scheduleDate }}
            {{
              patientInfo.schedulePeriodStart
                ? patientInfo.schedulePeriodStart +
                  '-' +
                  patientInfo.schedulePeriodEnd
                : ''
            }}</el-col
          >
        </el-row>
        <el-row
          :gutter="20"
          style="margin-top: 20px"
          v-if="patientInfo.treatmentType === 2"
        >
          <el-col :span="6"
            >初次诊断时间：{{ patientInfo.initialDiseaseTime }}</el-col
          >
          <el-col :span="18"
            >初次诊断疾病：{{ patientInfo.initialDisease }}</el-col
          >
        </el-row>
        <!-- 戒烟指导 -->
        <p v-if="Number(patientInfo.goodsId) === 9">
          <el-row :gutter="20" style="margin-top: 20px">
            <el-col :span="6"
              >吸烟情况：{{ patientInfo.smoking.smokingStatus }}</el-col
            >
            <el-col :span="6"
              >日吸烟量：{{ patientInfo.smoking.dailySmokingQuantity }}</el-col
            >
            <el-col :span="6"
              >烟龄：{{ patientInfo.smoking.smokingYear || 0 }}年</el-col
            >
          </el-row>
          <el-row :gutter="20" style="margin-top: 20px">
            <el-col :span="6"
              >开始吸烟年龄：{{
                patientInfo.smoking.smokingYears || 0
              }}岁</el-col
            >
            <el-col :span="6"
              >戒烟年限：{{ patientInfo.smoking.cigarettes || 0 }}年</el-col
            >
            <el-col :span="6"
              >是否家族肺癌史：{{ patientInfo.smoking.lungCancerHis }}</el-col
            >
          </el-row>
        </p>
        <div style="margin: 20px 0">
          {{ Number(patientInfo.goodsId) === 8 ? '需求描述：' : '主诉：'
          }}{{ patientInfo.described }}
        </div>
        <div
          v-if="
            Number(patientInfo.goodsId) === 8 && patientInfo.reportList.length
          "
        >
          体检报告：<span
            class="report"
            @click="getReportPdf(patientInfo.reportList[0].reportKey)"
            >{{ patientInfo.reportList[0].reportName }}</span
          >
        </div>
        <div
          v-if="symptomList.length"
          style="display: flex; align-items: center; margin: 20px 0"
        >
          <div>检查单/患处照片：</div>
          <el-image
            v-for="(item, index) in symptomList"
            :key="index"
            style="width: 50px; height: 50px; margin-right: 10px"
            :src="item"
            fit="cover"
            :preview-src-list="setPreviewList(item)"
          ></el-image>
        </div>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="title">填写病历</span>
      </div>
      <div class="p_bd">
        <el-form
          :inline="true"
          :model="patientInfo"
          label-position="top"
          class="demo-form-inline"
        >
          <el-form-item label="现病史" prop="hip">
            <el-input
              type="textarea"
              autosize
              v-model="patientInfo.hip"
              :maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="既往史">
            <el-input
              type="textarea"
              autosize
              v-model="patientInfo.patientHistory"
              :maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="个人史">
            <el-input
              type="textarea"
              autosize
              v-model="patientInfo.personalHistory"
              :maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="家族史">
            <el-input
              type="textarea"
              autosize
              v-model="patientInfo.familyHistory"
              :maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item class="irritability" label="过敏史">
            <el-input
              type="textarea"
              autosize
              v-model="patientInfo.allergyHistory"
              :maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="用药史">
            <el-input
              type="textarea"
              autosize
              v-model="patientInfo.drugHistory"
              :maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="手术史">
            <el-input
              type="textarea"
              autosize
              v-model="patientInfo.operationHistory"
              :maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="其他">
            <el-input
              type="textarea"
              autosize
              v-model="patientInfo.other"
              :maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="病史小结">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              v-model="patientInfo.patientRes"
              :maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="诊断结果">
            <el-input
              v-model="patientInfo.treatmentRes"
              @focus="diagnoseResult = true"
              placeholder="请选择内容"
              readOnly
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-col :span="24">
        <el-button
          @click="updateCase"
          style="width: 100%; margin-top: 10px"
          type="primary"
          >{{ SIGNATURE_STATUS[patientInfo.doctorSignatureStatus] || '提交' }}</el-button
        >
      </el-col>
    </el-card>
    <el-card class="box-card" v-if="patientInfo.treatmentType === 2">
      <div slot="header" class="clearfix">
        <span class="title">处方开药</span>
        <el-button
          style="float: right; padding: 0"
          type="text"
          icon="el-icon-plus"
          @click="prescriptionSelect"
          >添加药品</el-button
        >
      </div>
      <el-table :key="aaa" :data="patientInfo.recipeDrugReqs" border>
        <el-table-column
          prop="drugs.name"
          align="center"
          label="药品名称"
        ></el-table-column>
        <el-table-column
          prop="drugs.actualSpecs"
          align="center"
          label="药品规格"
        ></el-table-column>
        <el-table-column prop="recipeDrugs.drugNum" align="center" label="数量">
          <template slot-scope="scope">
            <span
              >{{ scope.row.recipeDrugs && scope.row.recipeDrugs.drugNum }}
              {{
                scope.row.recipeDrugs && scope.row.recipeDrugs.packUnit
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="recipeDrugs.useDays"
          align="center"
          label="用药天数"
        ></el-table-column>
        <el-table-column
          prop="recipeDrugs.dose"
          align="center"
          label="单次用量"
        >
          <template slot-scope="scope">
            <span
              >{{ scope.row.recipeDrugs && scope.row.recipeDrugs.dose }} /
              {{
                scope.row.recipeDrugs && scope.row.recipeDrugs.doseUnitValue
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="recipeDrugs.frequencyUnitValue"
          align="center"
          label="给药频率"
        >
        </el-table-column>
        <el-table-column
          prop="recipeDrugs.drugDirectionsValue"
          align="center"
          label="给药途径"
        >
          <template slot-scope="scope">
            <span>
              {{
                drugDirectionsObjAll[scope.row.recipeDrugs.drugDirections]
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="recipeDrugs.adUsage"
          align="center"
          label="补充说明"
        ></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="handleClick(scope.$index)"
            ></el-button>
            <el-button
              @click="deleteClick(scope.row)"
              type="text"
              icon="el-icon-delete"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 审批流程 -->
      <div
        class="approval"
        v-if="
          patientInfo.recipe && PRESCRIPTION_STATUS[patientInfo.recipe.status]
        "
      >
        <span>审批状态：</span
        ><span class="approval-status">{{
          patientInfo.recipe && PRESCRIPTION_STATUS[patientInfo.recipe.status]
        }}</span
        ><span class="approval-detail" @click="approvalDetail()">查看详情</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="24">
          <!-- TODO 修改提交逻辑-->
          <el-button
            v-if="!PrescriptionStatus || [11800,11808,11809].indexOf(PrescriptionStatus) !== -1"
            @click="saveHisCase"
            style="width: 100%; margin-top: 10px"
            type="primary"
            >{{[11808,11809].indexOf(PrescriptionStatus) !== -1 ? '再次提交' : '提交'}}</el-button
          >
        </el-col>
        <!-- <el-col :span="12">
          <el-button
            @click="processDialogVisible = true"
            style="width: 100%"
            type="primary"
            >审批流程</el-button
          >
        </el-col> -->
      </el-row>
    </el-card>
    <!-- <el-button
      v-show="
        ($route.query.status == 10002 && PrescriptionStatus == 11801) ||
        ($route.query.status == 10002 && PrescriptionStatus == '')
          ? true
          : false
      "
      @click="saveHisCase"
      type="primary"
      style="width: 100%"
      >提交</el-button
    > -->

    <!-- 弹窗 this.drugShow = true; -->
    <el-dialog :visible.sync="drugShow" width="80%" center>
      <drug-panel
        v-if="drugShow"
        @on-drug-add="onDrugAdd"
        :drugs="drugs"
        :drugNumSpcesObjAll="drugNumSpcesObjAll"
        ref="drugPanel"
      />
    </el-dialog>
    <!-- 弹窗 this.drugShow = true; -->
    <el-dialog :visible.sync="diagnoseResult" width="50%" center>
      <disease-code
        @on_disease_code="on_disease_code"
        :departmentId="sickInfo.departmentId"
      />
    </el-dialog>

    <!-- 提交处方时手机号码验证 -->
    <el-dialog
      title="手机号码验证"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-dynamic"
      >
        <el-form-item prop="phone">
          <el-input
            v-model="ruleForm.phone"
            placeholder="请输入手机号码"
            disabled
          >
            <i slot="prefix" class="el-input__icon el-icon-user"></i>
          </el-input>
        </el-form-item>
        <el-form-item class="phone-code" prop="code">
          <el-input
            v-model.trim="ruleForm.code"
            placeholder="请输入验证码"
            style="width: 80%; margin-right: 7px"
          >
            <i
              slot="prefix"
              class="el-input__icon el-icon-chat-line-square"
            ></i> </el-input
          ><el-button @click.prevent="getPhoneCode()">{{
            isCodeFlag ? codeNum + 's后重新获取' : codeNum
          }}</el-button>
        </el-form-item>
        <el-form-item class="phone-code">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import drugPanel from '@/components/drugPanel';
import diseaseCode from '@/components/diseaseCode';
import AdverseEvent from '@/components/common/AdverseEvent';
import util from '@/utils';
import { PATINET_GOODSID, PRESCRIPTION_STATUS, SIGNATURE_STATUS } from '@/utils/constants.js';

import {
  prescriptionAdd,
  drugSearch,
  getSystem,
  memberInfoByAccId,
  getOrderDetail,
  saveHisRecipeReq,
  addDictMap,
  getRecipe,
  caseQueryById,
  recipeSaveCode,
  updateCase,
  editHisRecipeReq,
  getReport,
} from '@/api';
import { webCall } from '@/api/doctor';
export default {
  name: 'Perscription',
  components: {
    drugPanel,
    diseaseCode,
    AdverseEvent,
  },
  created() {
    this.flag = this.$route.query.type;
    this.addDictMap();
    this.getOrderDetail();
  },
  data() {
    return {
      codeNum: '获取验证码',
      isCodeFlag: false,
      centerDialogVisible: false,
      ruleForm: {},
      PrescriptionStatus: '',
      PATINET_GOODSID,
      PRESCRIPTION_STATUS,
      SIGNATURE_STATUS,
      count: '',
      show: true,
      aaa: 0,
      tableData: [],
      DiseaseData: [],
      consFlag: false,
      flag: '', //标识 判断是从问诊订单进入还是远程会诊
      uid: util.timest(),
      // restaurants: [],
      timeout: null,
      isHistory: false,
      elSelect: false,
      chatType: '',
      lastPageName: '聊天',
      seconds: 0, //短信验证码读秒
      sendCodeBtnDisable: false,
      phoneCaptcha: '',
      mobilePhone: '',
      uploadUrl: util.Host + 'pc/publics/upload',
      leftBtnOptions: {
        backText: ' ',
        preventGoBack: true,
      },
      caseForm: {
        drugs_id: '',
        drugNum: '',
        dose: '',
        doseUnitValue: '',
        frequencyUnit: '',
        from: '',
        time: '',
        useDays: '',
        adUsage: '',
        drmodel: '',
        price: '',
        id: '',
      },
      prescription_type: '',
      diagnose_result: '',
      prRemark: '',
      disease_code: '',
      options: [], //药品
      value: '',
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
            message: '请输入合法手机号/电话号',
            trigger: 'blur',
          },
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'change' }],
      },
      sickInfo: {
        caseContent_dictText: {},
      },
      fileList: [],
      editableTabsValue: '0',
      editableTabs: [], //药品标题数组
      tabIndex: -1,
      select: '',
      drugs: [],
      tabTitleIndex: '',
      drugs_system_list: [],
      activeName: 'first',
      pageNum: 0,
      drugShow: false,
      selectDrugList: [],
      curDrugItem: '',
      diagnoseResult: false,

      audio: '',
      callTimer: null,
      isReciveCall: false,
      account: '',
      targetInfo: '',
      sureResult: false,

      patientInfo: {
        recipeDrugReqs: [],
        hip: '',
        recipe: {
          status: 0,
        },
        smoking: {},
        reportList: [],
      },
      imgsList: [],
      dateTime: '',
      drugDirectionsObjAll: {},
      drugNumSpcesObjAll: {},
      frequencyObjAll: {},
      recipeAddType: 0, // 0为添加，1为修改
      symptomList: [],
      // account: config.target,
      // sureResult:false,
      // prescriptionId:"",
      // fromType:"",//从最近咨询或者订单列表进入
    };
  },
  filters: {
    getName: function (value) {
      if (value) {
        return value.title;
      }
      return '图文问诊';
    },
    headerFilter: function (img) {
      if (img) {
        return img;
      } else {
        return require('@/assets/images/user-avatar.svg');
      }
    },
  },
  computed: {
    myInfo() {
      return this.$store.state.myInfo;
    },
    userInfos() {
      return this.$store.state.userInfos;
    },
    robotInfos() {
      return this.$store.state.robotInfos;
    },
    canLoadMore() {
      return !this.$store.state.noMoreHistoryMsgs;
    },
    systemInfo() {
      return this.$store.state.systemInfo;
    },
    roomListenType() {
      return this.$store.state.roomListenData.eventType;
    },
    roomListenData() {
      return this.$store.state.roomListenData;
    },
    setRoomStatus() {
      return this.$store.state.setRoomStatus;
    },
    sessionId() {
      let sessionId = this.$route.query.sessionId;
      return sessionId;
    },
    scene() {
      return util.parseSession(this.sessionId).scene;
    },
    to() {
      return util.parseSession(this.sessionId).to;
    },
  },
  methods: {
    // 验证码校验弹窗
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          this.updateCase();
          this.saveHisRecipeReq();
        } else {
          return false;
        }
      });
    },
    // 获取验证码
    async getPhoneCode() {
      if (!this.ruleForm.phone) return this.$message.error('手机号码不能为空');
      let isPhone = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/.test(
        this.ruleForm.phone,
      );
      if (!isPhone) return this.$message.error('手机号格式不正确');
      const params = { mobile: this.ruleForm.phone };
      const res = await recipeSaveCode(params);
      if (res.code == 1) {
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.codeNum = TIME_COUNT;
          this.isCodeFlag = true;
          this.timer = setInterval(() => {
            if (this.codeNum > 0 && this.codeNum <= TIME_COUNT) {
              this.codeNum--;
            } else {
              this.isCodeFlag = false;
              clearInterval(this.timer);
              this.timer = null;
              this.codeNum = '获取验证码';
            }
          }, 1000);
        }
      }
    },
    // 呼叫电话
    async subWebCall() {
      const query = {
        orderNo: this.$route.query.treatId,
      };
      const res = await webCall(query);
      if (res.code == 1) {
        this.callphone();
        if (res.data.succeed && res.data.message == '4') {
          this.$message.success('已接听');
        }
        if (res.data.succeed && res.data.message == '0') {
          this.$message.warning('线路繁忙/异常');
        }
        if (res.data.succeed && res.data.message == '8') {
          this.$message.warning('线路繁忙/异常');
        }
        if (res.data.succeed && res.data.message == '3') {
          this.$message.success('被叫拒绝/振铃未接/占线/关机/空号');
        }
        if (res.data.succeed && res.data.message == '5') {
          this.$message.success('余额不足，请先检查账户资费');
        }
      }
    },
    callphone() {
      const TIME_COUNT = 60;
      if (!this.timeNum) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timeNum = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timeNum);
            this.timeNum = null;
          }
        }, 1000);
      }
    },

    setPreviewList(msg) {
      let list = [];
      list.push(msg);
      return list;
    },
    async getOrderDetail(val) {
      const params = {
        orderNo: this.$route.query.treatId,
      };
      const res = await getOrderDetail(params);
      if (res.code == 1) {
        this.patientInfo = {
          ...res.data.orderTreatment,
          ...res.data.orderTreatmentCase,
        };
        this.patientInfo.smoking = res.data.smoking;
        this.patientInfo.reportList = res.data.reportList;
        this.patientInfo.recipeId = res.data.recipeId;
        if (this.patientInfo.recipeId) {
          this.getRecipe();
        }
        this.caseQueryById(val);
        this.patientInfo.recipeDrugReqs = [];
      }
    },
    async addDictMap() {
      const res = await addDictMap();
      if (res.code == 1) {
        this.drugs_system_list = res.data;
        const drugDirections = res.data.route || []; // 给药途径
        const drugNumSpce = res.data.packUnit || []; // 包装单位
        const frequency = res.data.frequency || []; // 给药频次
        const drugDirectionsObj = {};
        const drugNumSpcesObj = {};
        const frequencyObj = {};
        drugDirections.forEach((item) => {
          drugDirectionsObj[item.id] = item.name;
        });
        drugNumSpce.forEach((item) => {
          drugNumSpcesObj[item.id] = item.name;
        });
        frequency.forEach((item) => {
          frequencyObj[item.name] = item.id;
        });
        this.drugDirectionsObjAll = drugDirectionsObj;
        this.drugNumSpcesObjAll = drugNumSpcesObj;
        this.frequencyObjAll = frequencyObj;
      }
    },
    async caseQueryById(val) {
      const params = {
        orderNo: this.$route.query.treatId,
      };
      const res = await caseQueryById(params);
      if (res.code === 1) {
        const data = res.data.cases;
        if (data.symptom)
          this.symptomList =
            data.symptom.indexOf(',') != -1
              ? data.symptom.split(',')
              : [data.symptom];
        this.patientInfo.described = data.described;
        this.patientInfo.doctorSignatureStatus = data.doctorSignatureStatus;
        this.$set(this.patientInfo, 'hip', data.hip);
        this.$set(this.patientInfo, 'allergyHistory', data.allergyHistory);
        this.$set(this.patientInfo, 'drugHistory', data.drugHistory);
        this.$set(this.patientInfo, 'familyHistory', data.familyHistory);
        this.$set(this.patientInfo, 'operationHistory', data.operationHistory);
        this.$set(this.patientInfo, 'patientHistory', data.patientHistory);
        this.$set(this.patientInfo, 'patientRes', data.patientRes);
        this.$set(this.patientInfo, 'personalHistory', data.personalHistory);
        this.$set(this.patientInfo, 'treatmentRes', data.treatmentRes);
        this.$set(this.patientInfo, 'other', data.other);
        if (val) {
          this.$store.dispatch('sendMsg', {
            type: 'custom',
            scene: this.scene,
            to: this.to,
            pushContent: '[处方消息]',
            content: {
              type: 6,
              data: {
                value: data.treatmentRes,
                date: this.dateTime,
                orderNo: this.patientInfo.recipeId,
              },
            },
          });
        }
      }
    },
    async getRecipe() {
      const params = {
        recipeId: this.patientInfo.recipeId,
      };
      const res = await getRecipe(params);
      if (res.code == 1) {
        this.aaa = Math.random();
        this.PrescriptionStatus = res.data.recipe.status;
        this.patientInfo.recipeDrugReqs = res.data.recipeDrugs; // 处方药品
        this.patientInfo.recipe = res.data.recipe;
        if (res.data.recipeDrugs.length > 0) {
          this.recipeAddType = 1;
        }
      }
    },
    // 删除
    deleteClick(item) {
      let curIndex;
      this.patientInfo.recipeDrugReqs.filter((cur, index, arr) => {
        if (item.id == cur.id) {
          curIndex = index;
        }
      });
      this.patientInfo.recipeDrugReqs.splice(curIndex, 1);
    },
    handleClick(index) {
      const obj = {
        ...this.patientInfo.recipeDrugReqs[index].drugs,
        ...this.patientInfo.recipeDrugReqs[index].recipeDrugs,
      };

      this.drugShow = true;
      const a = JSON.parse(JSON.stringify(obj));
      this.$nextTick(() => {
        this.$refs.drugPanel.initDetail(a);
      });
    },
    onDrugAdd(items) {
      this.drugShow = false;
      let curIndex = '';

      if (!this.patientInfo.recipeDrugReqs) {
        this.patientInfo.recipeDrugReqs.push(items);
      } else {
        let same = this.patientInfo.recipeDrugReqs.filter((cur, index, arr) => {
          if (items.id == cur.recipeDrugs.id) {
            curIndex = index;
          }
          return items.id == cur.recipeDrugs.id;
        });

        if (same && same.length != 0) {
          this.patientInfo.recipeDrugReqs[curIndex] = {
            ...this.patientInfo.recipeDrugReqs[curIndex],
            ...items,
          };
          this.aaa = Math.random();
        } else {
          this.patientInfo.recipeDrugReqs.push(items);
        }
      }
    },
    // 提交
    saveHisCase() {
      // 添加手机号验证
      this.patientInfo.orderNo = this.$route.query.treatId;
      if (this.$route.query.type == 'replenishment') {
        this.patientInfo.channelCode = 'budan';
      }

      if (!this.patientInfo.recipeDrugReqs) {
        this.patientInfo.recipeDrugReqs = [];
      }
      if (!this.patientInfo.treatmentRes)
        return this.$message.error('请选择诊断结果');
      if (!this.patientInfo.recipeDrugReqs.length)
        return this.$message.error('请添加药品');
      //发送验证码
      this.ruleForm.phone = this.patientInfo.doctorMobile;
      this.centerDialogVisible = true;
    },
    // 保存病历
    async updateCase() {
      if(!this.patientInfo.patientRes){
        this.$message({
          type: 'error',
          message: '病历小结不能为空',
        });
        return;
      }
      if(!this.patientInfo.treatmentRes){
        this.$message({
          type: 'error',
          message: '诊断结果不能为空',
        });
        return;
      }
      // 病历字段的变更
      this.patientInfo.orderTreatmentCaseReq = {
        allergyHistory: this.patientInfo.allergyHistory, // 过敏史
        drugHistory: this.patientInfo.drugHistory, // 用药史
        familyHistory: this.patientInfo.familyHistory, // 家族史
        hip: this.patientInfo.hip, // 现病史
        operationHistory: this.patientInfo.operationHistory, // 手术史
        orderNo: this.patientInfo.orderNo, // 订单号
        patientHistory: this.patientInfo.patientHistory, // 过往病史
        patientRes: this.patientInfo.patientRes, // 病史小结
        personalHistory: this.patientInfo.personalHistory, // 个人史
        diseaseId: this.patientInfo.diseaseId, // 诊断结果疾病ID
        treatmentRes: this.patientInfo.treatmentRes, // 诊断结果name
        other: this.patientInfo.other, // 其它
      };
      await updateCase(this.patientInfo.orderTreatmentCaseReq); // 修改病历
      this.$message({
        type: 'success',
        message: '病历保存成功',
      });
    },
    // 保存处方信息
    async saveHisRecipeReq() {
      let newRecipeDrugReqs = [];
      this.patientInfo.recipeDrugReqs.forEach((item) => {
        let newItem = {};
        if (item.id) {
          newItem = {
            dose: item.dose, // 每次剂量
            doseUnit: item.doseUnit, // 每次剂量单位
            doseUnitValue: item.doseUnitValue, // 每次剂量单位
            drugDirections: item.drugDirections, // 用药途径
            drugDirectionsValue: this.drugDirectionsObjAll[item.drugDirections], // 用药途径
            drugId: item.id, // 对应药品ID
            drugNum: item.drugNum, // 药品数量
            drugNumUnit: 0, // 药品数量单位
            drugNumUnitValue: item.packUnit, // 药品数量单位
            frequency: 0, // 使用频度
            frequencyUnit: this.frequencyObjAll[item.frequencyUnitValue], // 使用频度单位
            frequencyUnitValue: item.frequencyUnitValue, // 使用频度单位
            adUsage: item.adUsage, // 备注
            useDays: item.useDays, // 用药天数
          };
        } else {
          newItem = item.recipeDrugs;
        }

        newRecipeDrugReqs.push(newItem);
      });

      //保存处方信息
      const params = {
        code: this.ruleForm.code,
        mobile: this.ruleForm.phone,
        orderNo: this.$route.query.treatId,
        recipeDrugReqs: newRecipeDrugReqs,
      };
      let res = { code: 0 };
      if (this.recipeAddType == 1 && [11808,11809].indexOf(this.PrescriptionStatus) == -1) {
        params.recipeId = this.patientInfo.recipeId; //处方id
        res = await editHisRecipeReq(params);
      } else {
        res = await saveHisRecipeReq(params);
      }

      this.getNowTime();

      if (res.code == 1) {
        this.centerDialogVisible = false; // 关闭手机验证弹窗
        if (this.$route.query.type == 'replenishment') {
          this.$message({
            type: 'success',
            message: '处方保存成功',
          });
          this.$router.push({
            path: 'appointment',
          });
        } else {
          this.getOrderDetail('send');
          // 给患者端发送处方消息
          this.$message({
            type: 'success',
            message: '处方消息发送成功',
          });
        }
      }
    },
    getNowTime() {
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes();
      this.dateTime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf;

      // console.log(dateTime)
      // return dateTime
    },
    estarPhone(phoneNum) {
      if (phoneNum) {
        let str = String(phoneNum),
          strLen = str.slice(-7, -3);
        return str.replace(strLen, '****');
      } else {
        return '手机号未设置';
      }
    },
    //获取手机验证码登录
    // async getPhoneCaptcha() {
    //   this.mobilePhone = this.sickInfo.doctorMobile;
    //   if (this.mobilePhone === "") {
    //     this.elementTips("error", "手机号码不能为空");
    //     return;
    //   }
    //   let isPhone =
    //     /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/.test(
    //       this.mobilePhone
    //     );
    //   if (!isPhone) {
    //     this.elementTips("error", "手机格式不正确");
    //     return;
    //   }
    //   const params = {
    //     mobile: this.mobilePhone,
    //     smsMode: "6",
    //   };
    //   let res = await recipeSaveCode(params);
    //   console.log("获取验证码", res);
    //   const { code, message } = res;

    //   if (code === 200) {
    //     this.countDown();
    //     this.elementTips("success", message);
    //     this.sendCodeBtnDisable = true;
    //   } else {
    //     this.sendCodeBtnDisable = false; //错误的情况下 解除禁止
    //     this.elementTips("warning", message);
    //   }
    // },
    countDown() {
      this.seconds = 60;
      this.secondsTimeId = setInterval(() => {
        if (this.seconds > 0 && this.seconds <= 60) {
          this.seconds--;
        } else {
          clearInterval(this.secondsTimeId);
          this.seconds = 0;
          this.sendCodeBtnDisable = false;
        }
      }, 1000);
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = '';
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    /**
     * 诊断结果
     */
    on_disease_code(data, type) {
      this.diagnoseResult = type;
      this.patientInfo.treatmentRes = data.title;
      this.patientInfo.diseaseId = data.id;
    },
    changeType(keyword) {
      if (keyword == 1 || keyword == 2) {
        this.pageNum = 0; //切换药品类型时，重置为0，下面+1 = 1 访问成1
      }
      this.pageNum = this.pageNum + 1;
      this.options = [];
      let data = {
        type: this.prescription_type,
        keyword: this.value,
        cate_id: '1',
        pageNum: this.pageNum,
        pageSize: '10',
      };
      drugSearch(data).then((res) => {
        this.options = this.options.concat(res.data.data);
      });
    },
    tipsMessage() {
      if (this.sessionId == this.superMan) {
        return;
      }
      //读取sessionStorage 提示只提示一次
      const tipsMessage = JSON.parse(sessionStorage.getItem('tipsMessage'));
      if (tipsMessage == 1) {
        return;
      }
      //将信息存入本地缓存sessionStorage
      sessionStorage.setItem('tipsMessage', JSON.stringify(1));
      this.$notify({
        title: '温馨提示',
        dangerouslyUseHTMLString: true,
        message: `<div>1、医生须完整查看患者病历后开始诊疗行为。</div>
          <div>2、根据相关规定，互联网医院不得为低龄儿童（6岁以下）开具互联网儿童用药处方。</div>
          <div>3、根据相关规定，互联网医院不得开具麻醉药品、精神药品等特殊管理药品的处方。</div>
          <div>4、本互联网医院平台仅提供复诊服务、不做初诊。</div>`,
        type: 'warning',
        duration: 0,
      });
    },
    /*
        切换药品事件
        通过两个数组对应索引的位置赋值
      */
    tabClick(item) {
      this.tabTitleIndex = item.index;
      for (let i = 0; i < this.drugs.length; i++) {
        if (item.index == i) {
          this.caseForm = this.drugs[i];
        }
      }
    },

    isTipPreOrder() {
      const that = this;
      this.$confirm(
        '您的处方已被拒绝，需要您再次查看病历信息，处方信息以后继续操作?',
        '提示',
        {
          confirmButtonText: '前去查看',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
        .then(() => {
          sessionStorage.setItem(
            'tipPreOrder' + that.sickInfo.orders_id,
            JSON.stringify(1),
          );
          that.detailHandle(that.sickInfo);
        })
        .catch(() => {
          // 取消  啥也不干 不能再提交处方
        });
    },

    /**
     * 添加药品按钮
     *
     * 条件1.tipPreOrder存在（查看处方）2.tipPreOrder值为！1  3.订单id相同 4.必须是拒绝状态 -1 -2
     **/
    prescriptionSelect() {
      const that = this;
      const tipPreOrder = JSON.parse(
        sessionStorage.getItem('tipPreOrder' + that.sickInfo.orders_id),
      );
      if (
        this.sickInfo.status == 3 ||
        this.sickInfo.status == 4 ||
        this.sickInfo.status == 7 ||
        this.sickInfo.status == 8
      ) {
        if (tipPreOrder == null) {
          this.isTipPreOrder();
        } else {
          this.drugShow = true;
          // this.$nextTick(() => {
          //   this.$refs.drugPanel.initRight();
          // });
        }
      } else {
        this.drugShow = true;
        // this.$nextTick(() => {
        //   this.$refs.drugPanel.initRight();
        // });
      }
    },
    /**
     * 输入监听事件
     */
    input(value) {
      this.$forceUpdate();
      let tabIndex = this.tabTitleIndex || this.tabIndex; //当前数组索引
      let drugs = this.drugs;
      for (let i = 0; i < this.drugs.length; i++) {
        if (tabIndex == i) {
          if (value === 'drugNum') {
            drugs[tabIndex].drugNum = this.caseForm.drugNum;
          } else if (value === 'dose') {
            drugs[tabIndex].dose = this.caseForm.dose;
          } else if (value === 'doseUnitValue') {
            drugs[tabIndex].doseUnitValue = this.caseForm.doseUnitValue;
          } else if (value === 'frequencyUnit') {
            drugs[tabIndex].frequencyUnit = this.caseForm.frequencyUnit;
          } else if (value === 'drugDirections') {
            drugs[tabIndex].drugDirections = this.caseForm.drugDirections;
          } else if (value === 'time') {
            drugs[tabIndex].time = this.caseForm.time;
          } else if (value === 'adUsage') {
            drugs[tabIndex].adUsage = this.caseForm.adUsage;
          } else if (value === 'useDays') {
            drugs[tabIndex].useDays = this.caseForm.useDays;
          }
        }
      }
    },
    loadMore() {},
    /**
     * 添加药方
     */
    addTab(targetName) {
      let selectedWorkName = {};
      selectedWorkName = this.options.find((item) => {
        return item.id === this.value;
      });
      let newTabName = ++this.tabIndex + '';
      this.editableTabs.push({
        title: selectedWorkName.content,
        name: newTabName,
        specs: selectedWorkName.specs,
        drugs_id: selectedWorkName.id,
      });
      /**
       * 如果过这里要增加或者减少字段，修改提交中的长度判断
       * //药品id
       * //名称
       * //药品规格
       * name用于模仿官方删除
       */
      let new_drugs = {
        drugs_id: selectedWorkName.id,
        drname: selectedWorkName.content,
        specs: selectedWorkName.specs,
        name: newTabName,
      };
      this.drugs.push(new_drugs);
      this.elSelect = false;
    },
    /**
     * 删除药品
     */
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      let drugs = this.drugs;
      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
      this.drugs = drugs.filter((tab) => tab.name !== targetName);
    },

    detailHandle(sickInfo) {
      let query = {
        casesId: this.sickInfo.caseContent_dictText.id,
        sessionId: this.sessionId,
        prescriptionId: sickInfo.prescriptionId,
      };
      this.$router.push({
        path: '/index/work/patientDetails',
        query,
      });
    },
    /*
        处方列表跳转
      */
    prescription() {
      this.$router.push({
        path: '/index/user/prescription',
      });
    },
    //获取下拉选项
    system_list() {
      let data = {
        type: 'all',
      };
      getSystem(data).then((res) => {
        this.drugs_system_list = res.data;
      });
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.content
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    //上传成功
    handleDataSuccess(res, file) {
      const that = this;
      this.caseForm.images.push(res.data.url);
    },
    //上传之前
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'jpg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('图片格式错误');
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`,
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    //药方添加
    setPrescription() {
      // 1.判断数组字段内容是否为空
      // 2.判断数组字段长度是否为12
      for (var i = 0; i < this.drugs.length; i++) {
        var new_drugs = this.drugs[i];
        const title = '';
        for (let k in new_drugs) {
          if (k == 'drname') {
            title = new_drugs[k];
          }
          if (
            new_drugs[k] == '' ||
            new_drugs[k] == undefined ||
            new_drugs[k] == null
          ) {
            this.$message.error(title + '药品有内容未填写');
            return;
          }
        }
        if (Object.keys(new_drugs).length < 10) {
          this.$message.error(title + '药品有内容未填写');
          return;
        }
      }
      this.$refs.caseForm.validate((valid) => {
        if (valid) {
          const params = {
            type: this.prescription_type,
            orders_id: this.sickInfo.orders_id,
            drugs: this.drugs,
            diagnose_result: this.diagnose_result,
          };
          prescriptionAdd(params).then((res) => {
            if (res.code === 1) {
              this.$message({
                type: 'success',
                message: res.message,
              });
              this.initPatientsInfo();
            } else {
              this.$message({
                type: 'error',
                message: res.message,
              });
            }
          });
        } else {
          this.$message({
            type: 'error',
            message: '请完成内容',
          });
          return false;
        }
      });
    },
    open() {
      this.$confirm(
        '不得为6岁以下儿童开具药品，不得开具毒、麻类药品!',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '',
          showCancelButton: false,
          // type: 'warning'
        },
      )
        .then(() => {
          this.addDrugForm();
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消提交'
          // });
        });
    },
    //药方添加new
    async addDrugForm() {
      try {
        var that = this;
        if (this.selectDrugList == '') {
          this.$message({
            type: 'error',
            message: '请添加药品',
          });
          return;
        }
        if (this.prRemark == '') {
          this.$message({
            type: 'error',
            message: '请添加病史小结',
          });
          return;
        }
        if (this.diagnose_result == '') {
          this.$message({
            type: 'error',
            message: '请选择诊断结果',
          });
          return;
        }
        if (this.phoneCaptcha == '') {
          this.$message({
            type: 'error',
            message: '验证码不能为空',
          });
          return;
        }
        if (this.phoneCaptcha == '') {
          this.$message({
            type: 'error',
            message: '验证码不能为空',
          });
          return;
        }

        const params = {
          type: this.selectDrugList[this.selectDrugList.length - 1].durgType, //多药品提交药方，药方类别不能和药品类别统一 :是个bug
          arrayDrug: this.selectDrugList,
          diagnoseResult: this.diagnose_result,
          diseaseCode: this.disease_code,
          captcha: this.phoneCaptcha,
          orderTreatId: this.sickInfo.treatId,
          memberId: this.sickInfo.id,
          prRemark: this.prRemark,
          // casesId: this.sickInfo.casesId,
          casesId: this.sickInfo.caseContent_dictText.id,
        };
        if (this.fromType === 'ask') {
          params.memberId = this.sickInfo.memberId;
        } else {
          params.memberId = this.sickInfo.id;
        }
        this.sureResult = true;
        let res = await prescriptionAdd(params);
        if (res.success) {
          this.$message({
            type: 'success',
            message: res.message,
          });
          sessionStorage.removeItem('tipPreOrder' + that.sickInfo.orders_id);
          this.initPatientsInfo();
          this.sureResult = true;
        } else {
          this.$message({
            type: 'error',
            message: res.message,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    getCaption(obj) {
      var index = obj.lastIndexOf('-');
      obj = obj.substring(index + 1, obj.length);
      return obj;
    },
    async getMemberInfoByAccId(sick_im_accid) {
      try {
        let data = {
          memberAccId: sick_im_accid,
        };
        let res = await memberInfoByAccId(data);
        if (res.success) {
          this.sickInfo = res.result;
          this.prescriptionId = res.result.prescriptionId;
          this.caseForm.orders_id = this.sickInfo.orders_id;
          this.initpPrescriptionDetail();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'error',
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async initpPrescriptionDetail() {
      // this.prescriptionSelect();
      try {
        if (
          this.prescriptionId !== '' &&
          (this.sickInfo.status == 7 || this.sickInfo.status == 4)
        ) {
          let data = {
            id: this.prescriptionId,
          };
          let res = await prescriptionDetail(data);
          if (res.success) {
            this.diagnose_result = res.result.diagnoseResult;
            this.selectDrugList = res.result.arrayDrug;
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'error',
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    getHistoryMsgs() {
      this.$store.dispatch('getHistoryMsgs', {
        scene: this.scene,
        to: this.to,
      });
    },
    goBack() {
      let fromType = this.$route.query.fromType;
      if (fromType == 'workdetail') {
        this.$router.push({
          path: '/index/user/patients',
        });
      } else {
        // this.$router.push({
        //   path: "/index/work/consultation",
        // });
        this.$router.push({
          path: '/index/work/patients',
        });
      }
    },
    handleCurrentChange(val) {},
    /**
     * 删除图片方法
     */
    handleRemove(file, fileList) {
      const url = file.response.data.url;
      for (var i = 0; i < this.caseForm.images.length; i++) {
        if (this.caseForm.images[i] == url) {
          this.caseForm.images.splice(i, 1);
        }
      }
    },
    handlePreview(file) {},
    onClickBack() {
      window.stopPlayAudio && window.stopPlayAudio();
      window.history.go(-1);
    },
    // 处方审批状态详情
    approvalDetail() {
      let query = {
        orderNo: this.$route.query.treatId,
        prescriptionId: this.patientInfo.recipe.id,
      };
      this.$router.push({
        path: '/index/work/prescriptionDetail',
        query,
      });
    },
    async getReportPdf(reportKey) {
      await getReport({
        reportKey,
      }).then((res) => {
        if (res.code === 1) {
          var oA = document.createElement('a'); //创建a标签
          oA.href = res.data; //添加 href 属性
          oA.target = '_blank'; //添加 target 属性
          oA.click(); //模拟点击
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.headerWarpper {
  margin: 15px 20px 0 5px;
}
/deep/ .el-table__empty-block {
  height: 15px !important;
}
/deep/ .el-table__empty-text {
  background: none !important;
  height: 100px !important;
  padding: 0 !important;
}
/deep/ .el-form--inline .el-form-item {
  width: 47%;
}
/deep/ .el-form--label-top .el-form-item__label {
  padding: 0;
}
.box-card {
  height: auto;
  /deep/ .el-form-item {
    margin-bottom: 5px;
  }
  /deep/ .el-form-item__label {
    line-height: 5px;
  }
}
.principle {
  width: 185%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.g-inherit {
  padding: 0 20px;
  // display: flex;
  // flex: 1;
  height: 100%;
  .mainContent {
    display: flex;
    // flex-direction: row;
    // flex: 1;
    margin: 15px 0;
    .chatContent {
      // flex: 1;
      margin: 0 20px 5px 20px;
      display: flex;
      height: 100%;
      width: 48%;
      // flex: 1;

      .c_ft {
        border-top: 1px solid #ccc;
        padding-top: 32px;
        position: relative;
      }
    }
    // .wrapper {
    //   flex: 1;
    //   width: 100%;
    //   position: relative;
    //   .table-content {
    //     position: absolute;
    //     width: 100%;
    //   }
    // }

    .patientsContent {
      // flex: 1;
      // flex: 0 0 40%;
      overflow: hidden;
      width: 50%;
      margin: auto;
      // display: flex;
      // flex-direction: column;
      .topBox {
        .p_bd {
          line-height: 30px;
          color: #606266;
          width: 100%;
          overflow: hidden;
          // display:flex;
          .txt {
            float: right;
          }
        }
      }

      .botBox {
        margin-top: 20px;
        margin-bottom: 5px;
        flex: 1;
        .prescription {
          color: #fc701a;
          padding: 12px 10px;
          margin-top: 2px;
          float: right;
          cursor: pointer;
        }
        .el-tabs__header {
          width: 80% !important;
        }
        .diagnosis {
          flex: 1;
        }
      }
    }
  }
  .clearfix {
    .title {
      padding-left: 15px;
      border-left: 3px solid #fc701a;
    }
  }
}
.pageWarpper {
  width: 100%;

  text-align: center;
}
.patientsContent .el-alert {
  margin-bottom: 20px;
}
.logo-ps {
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background-color: rgb(0, 175, 255);
  &::before {
    position: absolute;
    content: '';
    display: inline-block;
    width: 30px;
    height: 20px;
    background-color: rgba(255, 255, 255, 0.1);
  }
  &::after {
    position: absolute;
    content: 'RP';
    font-size: 16px;
    display: inline-block;
    color: #fff;
  }

  .prescrBtn {
    float: right !important;
    font-weight: 700 !important;
    margin-left: 20px;
  }
}
.superMan {
  flex: 0 0 96% !important;
}
.more {
  padding: 5px 0;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.6);
  cursor: pointer;
  text-align: center;
}
.drugList {
  margin: 20px 0;
  .drug_title {
    font-size: 16px;
    color: #409eff;
    margin: 10px 0;
  }
  .drug-item {
    .drug-edit {
      text-align: right;
      button {
        padding: 6px 19px !important;
      }
    }
  }
}

.topBox .el-button--text {
  color: #fc701a;
}

.topBox {
  .el-textarea__inner:focus {
    border-color: #fc701a !important;
  }
}
// .m-chat-editor {
//   .el-button {
//     background-color: #fc701a !important;
//     border-color: #fc701a !important;
//   }
// }

.el-tabs__nav-wrap::after {
  background-color: #fff !important;
}

.el-card__body .el-tabs__item.is-active {
  color: #fc701a;
  border-color: #fc701a !important;
}

.el-card__body .el-tabs__item:hover,
.el-card__body .el-button--text {
  color: #fc701a;
}

.el-card__body .el-tabs__active-bar {
  background-color: #fc701a;
}
.chat_warpper {
  height: 100%;
  display: flex;
  flex-direction: column;
  .out-box {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .chat-warpper__bottom {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    .c_bd {
      flex: 1;
      overflow: hidden;
      height: 100%;
    }
  }
}

.invite {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .avatar {
    width: 100px;
    height: 100px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .tip {
    margin: 20px 0;
  }
  .foot {
    width: 60%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .el-button {
      width: 120px;
    }
  }
}
.el_input {
  width: 50%;
  float: left;
  margin-right: 30px;
}
.el_image {
  width: 40%;
  // float: right;
  position: absolute;
  right: 0;
  top: 0;
}
.el_image img {
  vertical-align: middle;
}
.p_click {
  z-index: 999999;
  /* display: inline-table; */
  background: #b7b7b7;
  position: absolute;
  right: 0;
  color: #fff;
  padding: 0 5px;
  border-radius: 10px;
}
.captcha_phone p {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}
.captcha-item {
  position: relative;
  // right: -53px;
  // bottom: 0;
  width: 100%;
  margin-bottom: 10px;
}
.get-captcha {
  position: absolute;
  top: 7px;
  right: 2px;
  background-color: transparent;
  color: #fc701a;
  border: none; // 去掉边框
  outline: none; // 去掉点击按钮后的边框
  cursor: pointer;
}
.login-pass {
  border-style: none none none;
  border-bottom: 1px solid #dcdcdc;
  width: calc(100% - 30px);
  background-image: url('../../assets/images/login-pass.png');
  background-size: 15px 15px;
  background-position: 3px 4px;
  background-repeat: no-repeat;
  padding: 5px 10px 6px 20px;
}
.login-user:focus,
.login-pass:focus {
  outline: none;
}
// 过敏字段加粗变红
.irritability {
  /deep/ .el-form-item__label {
    font-weight: bold;
    color: red;
  }
}
/deep/ .el-dialog__header {
  padding: 20px;
  padding-bottom: 10px;
  color: #333538;
  font-weight: 600;
  float: left;
  padding: 25px 25px 30px;
}
.phone-code {
  /deep/ .el-form-item__content {
    display: flex;
  }

  /deep/ .el-button--primary {
    width: 50%;
    font-size: 16px;
    border-radius: 20px;
    margin: 0 auto;
  }
}
.approval {
  margin-top: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  line-height: 24px;
  &-status {
    color: #1a73fc;
  }
  &-detail {
    margin-left: 20px;
    color: #fc701a;
  }
  &-detail:hover {
    cursor: pointer;
  }
}
.report {
  border-bottom: 1px solid;
}
.report:hover {
  cursor: pointer;
}
</style>
